// @flow

import type { TimesheetProjection } from '../../common/typings';
import { subtractDates } from '../../utils/Utils';

export default function getTotalDurationMinutes(
  timesheetProjections: Array<TimesheetProjection>
): number {
  return timesheetProjections.reduce((prev, projection) => {
    if (projection.clockOut) {
      return prev + Math.floor(subtractDates(projection.clockOut, projection.clockIn) / 1000 / 60);
    }

    return prev;
  }, 0);
}
